import React, { createClass, PropTypes } from 'react';
import Icon from './icon';
import $ from 'jquery';

const Carousel = createClass({

  propTypes: {
    photos: PropTypes.array,
  },

  getInitialState() {
    return {
      index: 0,
    };
  },

  componentDidMount() {
    const resizeCss = function (wrapper) {
      const wRatio = 744 / this.naturalWidth;
      const hRatio = 320 / this.naturalHeight;
      const ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      }
    };
    $('.carouselImage').each(function (index, image) {
      const $image = $(image);
      $image.load(function () {
        resizeCss.call(this, $image);
      });
    });
  },


  componentWillUpdate() {
    const resizeCss = function (wrapper) {
      const wRatio = 744 / this.naturalWidth;
      const hRatio = 320 / this.naturalHeight;
      const ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      }
    };
    $('.carouselImage').each(function (index, image) {
      const $image = $(image);
      $image.load(function () {
        resizeCss.call(this, $image);
      });
    });
  },

  setIndex(index) {
    this.setState({ index });
  },

  moveRight() {
    if (this.state.index === this.props.photos.length - 1) {
      this.setState({
        index: 0,
      });
    } else {
      this.setState({
        index: this.state.index + 1,
      });
    }
  },

  moveLeft() {
    if (this.state.index === 0) {
      this.setState({
        index: this.props.photos.length - 1,
      });
    } else {
      this.setState({
        index: this.state.index - 1,
      });
    }
  },

  render() {
    const photos = (this.props.photos || []).map((photo, index) => {
      return (
        <li key={index}>
          <div className="carouselBackground">
            <img className="carouselImage" src={photo} key={index}/>
          </div>
        </li>
      );
    });

    const ulStyle = {
      width: `${photos.length * 125}%`,
      left: `${744 * (-this.state.index)}px`,
    };

    return (
      <div className="carousel">
        <div className="carousel-info-left" onClick={this.moveLeft}>
          <Icon className="tc-icon-chevron-left" />
        </div>
        <div className="carousel-inner">
          <ul style={ulStyle}>
            {photos}
          </ul>
        </div>
        <div className="carousel-info-right" onClick={this.moveRight}>
          <Icon className="tc-icon-chevron-right" />
        </div>
      </div>
    );
  },

});

export default Carousel;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/carousel.jsx